// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_defined.js
 ** module id = 273
 ** module chunks = 2 4 6 8 9 11 12
 **/